export type HealthFilterOptions = {
  from: number | null
  to: number | null
  isEmpty: boolean
  hasAnyValue?: boolean
}

function healthOrScore(item: { score?: number | null; health?: number | null }): number | null {
  return item.score ?? item.health ?? null
}

export const filterByHealth = <T extends { score?: number | null; health?: number | null }>(
  items: T[],
  { from, to, isEmpty, hasAnyValue }: HealthFilterOptions,
): T[] => {
  if (isEmpty) {
    return items.filter((item) => healthOrScore(item) === null)
  }

  if (hasAnyValue) {
    return items.filter((item) => healthOrScore(item) !== null)
  }

  if (from === null && to === null) {
    return items
  }

  return items.filter((item) => {
    const value = healthOrScore(item)
    if (value === null) return false
    if (from !== null && value < from) return false
    if (to !== null && value > to) return false
    return true
  })
}
